import { useParams } from "react-router-dom";
import "../LoginPage/LoginPage.css";
import "./RecoverPassPage.css";
import { FaLock } from "react-icons/fa";
import { ApiUrl } from "../../utils/Properties";
import Swal from "sweetalert2";
import axios from "axios";

function ForgotPasswordConfirmPage() {

    document.body.classList.add("background-recover-page");
    
    const { uid, token } = useParams();
  
    // Aquí puedes utilizar los valores de token y code para realizar las acciones necesarias
    // en la página de confirmación de contraseña olvidada
    const handleSubmit = (e) => {
      e.preventDefault();
      const password1 = e.target.password1.value;
      const password2 = e.target.password2.value;
  
      if (password1 !== password2) {
        Swal.fire({
          title: "Error!",
          text: "Los passwords no coinciden",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
        return;
      }
  
      axios
        .post(
          ApiUrl + "/auth/users/reset_password_confirm/",
          {
            uid: uid,
            token: token,
            new_password: password1,
            re_new_password: password1
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          Swal.fire({
            title: "Éxito!",
            text: "El password se ha cambiado correctamente",
            icon: "success",
            confirmButtonText: "Aceptar",
          }).then((result) => {
            window.location.href = "/";
          });
        })
        .catch((error) => {
          let response_data = error.response.data;
          Swal.fire({
            title: "Error!",
            html: response_data.new_password.map((item) => {
              return `${item}<br/>`;
            },),
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        });
    };
  
    return (
      <div className="wrapper">
        <form onSubmit={handleSubmit}>
          <h1>Recuperar Password</h1>
          <div className="input-box">
            <input type="password" placeholder="Password" name="password1" required />
            <FaLock className="icon" />
          </div>
          <div className="input-box">
            <input type="password" placeholder="Ingrese nuevamente el password" name="password2" required />
            <FaLock className="icon" />
          </div>
  
          <button type="submit">Recuperar Password</button>
  
          <div className="register-link">
            <p>
              Desarrollado por{" "}
              <a href="https://www.nosolotec.com/" target="_blank">
                Nosolotec SA
              </a>
            </p>
          </div>
        </form>
      </div>
    );
  }

export default ForgotPasswordConfirmPage;
